module.exports = {"id":"s2-q2c","text":"Did the training lead to a nationally recognised qualification or licence?","multiselect":false,"options":[{"id":"s2-q2c-a1","text":"Yes","next":"s2-q3","capability":2,"access":1},{"id":"s2-q2c-a2","text":"No","next":"s2-q3","capability":0,"access":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s2-q2c.json
// module id = 910
// module chunks = 32